import { Injectable } from '@angular/core';
import { AutoKeyDetailsListViewModel, AutoKeyViewModel, WorkOrderDetails, LockerDetail, ShareBoxLogFinalViewModel, AppointmentDetailByDealerIdViewModel } from '../business-entities/auto-key-model';
import { GenericResponse } from '../business-entities/generic-response';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';

@Injectable({
    providedIn: 'root'
})

export class AutoKeyDataService {
    constructor(private dataProvider: DataService) {
    }
    async getAutoKeyDetailsByDealer(dealerId: string): Promise<GenericResponse<AutoKeyDetailsListViewModel>> {
        return this.dataProvider.Get<GenericResponse<AutoKeyDetailsListViewModel>>(Urls.GetAutoKeyListByDealer, dealerId).toPromise();
    }

    async GetActiveReservationList(dealerId: string): Promise<GenericResponse<any>> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetActiveReservationList, dealerId).toPromise();
    }

    getWorkOrderDetails(model: any): Promise<GenericResponse<Array<WorkOrderDetails>>> {
        return this.dataProvider.Post<GenericResponse<Array<WorkOrderDetails>>>(Urls.GetWorkOrderDetails, model).toPromise();
    }

    unlockKeyLocker(autoKeyId : number, applicationId: number): Promise<GenericResponse<any>> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.ResetLocker, autoKeyId,applicationId).toPromise();
    }

    getAvailableLockers(dealerId: string): Promise<GenericResponse<Array<LockerDetail>>> {
        return this.dataProvider.Get<GenericResponse<Array<LockerDetail>>>(Urls.GetAvailableLockers, dealerId).toPromise();
    }

    reserveLocker(model: any): Promise<GenericResponse<boolean>> {
        return this.dataProvider.Post<GenericResponse<boolean>>(Urls.ReserveLocker, model).toPromise();
    }

    getAppointmentAutoKeyDetail(autoKeyId: number): Promise<GenericResponse<AutoKeyViewModel>> {
        return this.dataProvider.Get<GenericResponse<AutoKeyViewModel>>
            (Urls.GetAutoKeyDetail, autoKeyId).toPromise();
    }
    getShareboxLogData(appointmentId: Number){
        return this.dataProvider.Get<GenericResponse<ShareBoxLogFinalViewModel>>(Urls.GetShareboxLogData, appointmentId).toPromise();
    }
    GetAppointmentByDealerIdAndAppointmentId(dealerId: string, appointmentId:number){
        return this.dataProvider.Get<GenericResponse<AppointmentDetailByDealerIdViewModel[]>>(Urls.GetAppointmentByDealerIdAndAppointmentId, dealerId, appointmentId).toPromise();
    }
    AssignLockerToOrder(model: any) : Promise<GenericResponse<boolean>>{
        return this.dataProvider.Post<GenericResponse<boolean>>(Urls.AssignLockerToOrder, model).toPromise();
    }
    openLocker(autoKeyId : number,applicationId : number) :  Promise<GenericResponse<any>> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.OpenLocker, autoKeyId, applicationId).toPromise();
    }
}
